import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Cook-app static UI strings. Dish names are NOT translated here — they come
// pre-resolved from the backend (name_local / dish_name_local) per the cook's
// preferred language (set by admin only).
const resources = {
    en: {
        translation: {
            nav: { orders: 'Orders', recipes: 'Recipes', profile: 'Profile' },
            common: { logout: 'Logout', cancel: 'Cancel', id: 'ID' },
            dash: {
                welcomeBack: 'Welcome back',
                todaysOrders: "Today's Orders",
                pastOrders: 'Past Orders',
                myRecipes: 'My Recipes',
                locked: 'Locked',
                noUpcoming: 'No upcoming orders',
                noPast: 'No past orders yet',
                noRecipes: 'No recipes assigned to you yet',
                noLocked: 'No locked recipes',
                notifications: 'Notifications',
                noNotifications: 'No notifications yet',
                newOrder: 'New order',
                today: 'Today',
                tomorrow: 'Tomorrow',
                todaysOrdersHeading: "Today's Orders",
                tomorrowsOrdersHeading: "Tomorrow's Orders",
                dish: 'Dish',
                dishes: 'Dishes',
                mins: 'mins',
                labelBooking: 'BOOKING',
                labelCooking: 'COOKING',
                labelCompleted: 'COMPLETED',
                labelCancelled: 'CANCELLED',
            },
            detail: {
                orderDetails: 'Order Details',
                customer: 'Customer',
                dishesToCook: 'Dishes to Cook',
                address: 'Address',
                navigate: 'NAVIGATE',
                callCustomer: 'Call Customer',
                notesTitle: 'Notes from customer',
                amountToCollect: 'Amount to collect',
                cod: 'Cash on Delivery',
                cookTimeLabel: 'Cook Time',
                cookingTime: 'Cooking Time',
                orderCookTime: 'Order Cook Time',
                orderCompleted: 'Order Completed',
                startOrder: 'Start Order',
                confirmStart: 'Confirm Start',
                completeOrder: 'Complete Order',
                confirmComplete: 'Confirm Complete',
                startOtpPrompt: 'Enter the Start OTP shared by the customer',
                endOtpPrompt: 'Enter the End OTP shared by the customer',
                enterOtp: 'Enter 4-digit OTP',
                statusUpcoming: 'Upcoming',
                statusInProgress: 'In Progress',
                statusCompleted: 'Completed',
                statusCancelled: 'Cancelled',
            },
        },
    },
    hi: {
        translation: {
            nav: { orders: 'ऑर्डर', recipes: 'रेसिपी', profile: 'प्रोफ़ाइल' },
            common: { logout: 'लॉग आउट', cancel: 'रद्द करें', id: 'आईडी' },
            dash: {
                welcomeBack: 'वापसी पर स्वागत है',
                todaysOrders: 'आज के ऑर्डर',
                pastOrders: 'पुराने ऑर्डर',
                myRecipes: 'मेरी रेसिपी',
                locked: 'लॉक्ड',
                noUpcoming: 'कोई आगामी ऑर्डर नहीं',
                noPast: 'अभी तक कोई पुराना ऑर्डर नहीं',
                noRecipes: 'अभी तक आपको कोई रेसिपी नहीं दी गई',
                noLocked: 'कोई लॉक्ड रेसिपी नहीं',
                notifications: 'सूचनाएं',
                noNotifications: 'अभी तक कोई सूचना नहीं',
                newOrder: 'नया ऑर्डर',
                today: 'आज',
                tomorrow: 'कल',
                todaysOrdersHeading: 'आज के ऑर्डर',
                tomorrowsOrdersHeading: 'कल के ऑर्डर',
                dish: 'व्यंजन',
                dishes: 'व्यंजन',
                mins: 'मिनट',
                labelBooking: 'बुकिंग',
                labelCooking: 'पकाना',
                labelCompleted: 'पूर्ण',
                labelCancelled: 'रद्द',
            },
            detail: {
                orderDetails: 'ऑर्डर विवरण',
                customer: 'ग्राहक',
                dishesToCook: 'पकाने के लिए व्यंजन',
                address: 'पता',
                navigate: 'नेविगेट',
                callCustomer: 'ग्राहक को कॉल करें',
                notesTitle: 'ग्राहक के नोट्स',
                amountToCollect: 'वसूली राशि',
                cod: 'कैश ऑन डिलीवरी',
                cookTimeLabel: 'पकाने का समय',
                cookingTime: 'पकाने का समय',
                orderCookTime: 'ऑर्डर पकाने का समय',
                orderCompleted: 'ऑर्डर पूर्ण',
                startOrder: 'ऑर्डर शुरू करें',
                confirmStart: 'शुरू करने की पुष्टि करें',
                completeOrder: 'ऑर्डर पूरा करें',
                confirmComplete: 'पूरा करने की पुष्टि करें',
                startOtpPrompt: 'ग्राहक द्वारा साझा किया गया Start OTP दर्ज करें',
                endOtpPrompt: 'ग्राहक द्वारा साझा किया गया End OTP दर्ज करें',
                enterOtp: '4 अंकों का OTP दर्ज करें',
                statusUpcoming: 'आगामी',
                statusInProgress: 'चल रहा है',
                statusCompleted: 'पूर्ण',
                statusCancelled: 'रद्द',
            },
        },
    },
};

i18n.use(initReactI18next).init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
});

export default i18n;
